import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

export const refreshApp = (editorSDK: FlowEditorSDK) => {
  return editorSDK.application.livePreview.refresh('', {
    source: `PUBLIC_API_REFRESH`,
    shouldFetchData: true,
  });
};
